var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconDirection = function SvgIconDirection(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.775 8.231 8.5.853c-.3-.328-.75-.328-1.05 0L.225 8.23c-.3.328-.3.82 0 1.148l7.225 7.379c.3.328.75.328 1.05 0l7.275-7.38c.3-.327.3-.819 0-1.147ZM9 10.855v-2.05H7v2.46H5.5v-3.28c0-.492.3-.82.75-.82H9v-2.05l2.625 2.87L9 10.855Z",
    fill: "#4E6DF5"
  })));
};
export default SvgIconDirection;